import { z } from "zod";

export function getLocalStorageRecord<T>(key: string): T | null {
  const value = localStorage.getItem(key);
  if (value) {
    try {
      return JSON.parse(value);
    } catch (e) {
      localStorage.removeItem(key);
    }
  }

  return null;
}

export function saveLocalStorageRecord<T>(
  key: string,
  payload: T | null
): void {
  if (payload !== null) {
    localStorage.setItem(key, JSON.stringify(payload));
  } else {
    localStorage.removeItem(key);
  }
}

export function localStorageRecord<T>(key: string, schema: z.ZodSchema<T>) {
  return {
    getValue(): T | null {
      try {
        const value = localStorage.getItem(key);
        if (!value) return null;

        return schema.parse(JSON.parse(value));
      } catch (error: any) {
        console.warn(`Error getting stored value for ${key}:`, error?.message);
        return null;
      }
    },
    setValue(value: T | null) {
      saveLocalStorageRecord(key, value);
    },
  };
}
